module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/xpass-aba6a7a523513b14a660094a8d968763.png";